export const versionMaxLength = 32;
export const productSerialNumberMaxLength = 128;
export const subjectMaxLength = 255;
export const descriptionMaxLength = 15000;
export const troubleshootingStepsMaxLength = 1000;

export const getSupportTicketStatus = (status, t) => {
  switch (status) {
    case "creating":
      return t("pages.support.ticket.statusOptions.creating");
    case "new":
      return t("pages.support.ticket.statusOptions.new");
    case "in progress":
      return t("pages.support.ticket.statusOptions.inProgress");
    default:
      return t("pages.support.ticket.statusOptions.closed");
  }
};

export const getSupportTicketStatusColor = (status) => {
  switch (status) {
    case "creating":
      return "#DE0B15";
    case "new":
      return "#DE0B15";
    case "in progress":
      return "#7349FD";
    default:
      return "#CCCCCC";
  }
};

export const renderProductModel = (productModel) => {
  switch (productModel) {
    case "none":
      return "-";
    case "":
      return "-";
    default:
      return productModel;
  }
};

export const isEdgeDevice = (value, t) =>
  [
    t("pages.support.ticket.productSkuOptions.edgeIpsLe"),
    t("pages.support.ticket.productSkuOptions.edgeIpsStd"),
    t("pages.support.ticket.productSkuOptions.edgeIpsPro"),
    t("pages.support.ticket.productSkuOptions.edgeFireStd"),
  ].indexOf(value) > -1;

export const showProductSerialNumber = (productSKU) => {
  switch (productSKU) {
    case "StellarOne":
      return false;
    case "StellarProtect":
      return false;
    default:
      return true;
  }
};
